import { Link } from 'react-router-dom'
import { ReactComponent as Logo } from '../icons/logo.svg'
import { ReactComponent as PhoneIcon } from '../icons/telephone.svg'
import { ReactComponent as MessageIcon } from '../icons/message.svg'

export const Footer = () => {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          
          <div className="footer-section">
            <div className="footer-brand">
              <Logo className="footer-logo" />
              <div className="brand-text">
                <h3>Inter Home</h3>
                <p>El Internet Fácil</p>
              </div>
            </div>
            <p className="footer-description">
              Proveedor de servicios de internet residencial en Monterrey. 
              Sin contratos forzosos, precios justos y soporte técnico confiable.
            </p>
          </div>

          <div className="footer-section">
            <h4 className="footer-title">Nuestros Servicios</h4>
            <ul className="footer-links">
              <li><Link to="/">Internet Residencial</Link></li>
              <li><Link to="/plans">Planes de Internet</Link></li>
              <li><a href="#planes">Ver Precios</a></li>
              <li><a href="tel:8180178779">Solicitar Información</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-title">Información Legal</h4>
            <ul className="footer-links">
              <li><Link to="/ift">Cumplimiento IFT</Link></li>
              <li><Link to="/ift">Documentos PROFECO</Link></li>
              <li><Link to="/ift">Aviso de Privacidad</Link></li>
              <li><Link to="/ift">Código de Prácticas</Link></li>
              <li><Link to="/ift">Carta de Derechos</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-title">Contacto</h4>
            <div className="footer-contact">
              <div className="contact-item">
                <PhoneIcon className="contact-icon" />
                <div>
                  <span className="contact-label">Teléfono</span>
                  <a href="tel:8180178779" className="contact-link">
                    81 8017 8779
                  </a>
                </div>
              </div>
              
              <div className="contact-item">
                <MessageIcon className="contact-icon" />
                <div>
                  <span className="contact-label">Email</span>
                  <a 
                    href="mailto:Interhomecontacto@gmail.com" 
                    className="contact-link"
                  >
                    Interhomecontacto@gmail.com
                  </a>
                </div>
              </div>

              <div className="contact-item">
                <span className="contact-icon">📍</span>
                <div>
                  <span className="contact-label">Ubicación</span>
                  <span className="contact-text">Pregunta por nuestra cobertura</span>
                </div>
              </div>
            </div>
          </div>

        </div>

        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p className="copyright">
              © {currentYear} Inter Home México. Todos los derechos reservados.
            </p>
            <div className="legal-links">
              <Link to="/ift">Términos y Condiciones</Link>
              <span className="separator">|</span>
              <Link to="/ift">Política de Privacidad</Link>
              <span className="separator">|</span>
              <Link to="/ift">Regulaciones IFT</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}